import { render, staticRenderFns } from "./updHkrg.vue?vue&type=template&id=4493e252&scoped=true"
import script from "./updHkrg.vue?vue&type=script&lang=js"
export * from "./updHkrg.vue?vue&type=script&lang=js"
import style0 from "./updHkrg.vue?vue&type=style&index=0&id=4493e252&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4493e252",
  null
  
)

export default component.exports